var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"projectbox"},_vm._l((_vm.typrojectlist),function(item,index){return _c('div',{key:index,staticClass:"project",class:{act:_vm.act==index},on:{"click":function($event){return _vm.change(index)}}},[_vm._v(_vm._s(item))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }